//import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import clienteService from "./services/Clientes/clienteServiceClient";
import { toast } from 'react-toastify';

export default function useAuth() {
    const dispatch = useDispatch()
    const user = useSelector(state => state.user);
    //let history = useHistory();
    //const { setUser } = useContext(UserContext);

    const setUserContext = async (token) => {
        var res = await clienteService.me();
        if (res.succeeded) {
          let claim = res.object;
          //console.log("setUserContext: ", claim)
          localStorage.setItem('user', JSON.stringify(claim));
          dispatch({type: 'set', user: claim});

          if (claim.userMustChangePassword)
            window.open(`#/update-password`, '_self');
          else
            window.open(`#/facturas`, '_self');
        }            
    }

    const loginUser = async (data) => {
        var res = await clienteService.token(data);
        if (res.succeeded) {
          //console.log("loginUser: ", res.object)
          localStorage.setItem('token', res.object);
          //dispatch({type: 'set', token: res.object})
          await setUserContext(res.object);
          return res.object;
        } else {
          return null;
        }              
    }

    const signUpUser = async (data) => {
      var res = await clienteService.resetPassword(data);
      if (res.succeeded) {
        await setUserContext(res.object);
        return true;
      } else {
        toast.error(res.errorMessage ? res.errorMessage : 'There is a problem with the API service.'); 
        return null;
      }              
    }

    const updatePassword = async (data) => {
      var res = await clienteService.updatePassword(data);
      if (res.succeeded) {
        await setUserContext(res.object);
        return true;
      } else {
        toast.error(res.errorMessage ? res.errorMessage : 'There is a problem with the API service.'); 
        return null;
      }              
    }    

    const getUser = () => {
      let res = user;
      if (user === undefined || user === null) {
        res = localStorage.getItem('user');
      }
      return res;
    }
  
    const getToken = () => {
      return localStorage.getItem('token');
    }
  
    const isAuthenticated = () => {
      let user = getUser();
      return user !== undefined && user !== null;
    }
            
    const signOut = () => {
      localStorage.removeItem('token');
      localStorage.removeItem('user'); 
      dispatch({type: 'set', user: undefined});
    }

    const isTokenExpired = () => {
      let token = getToken();
      if (token !== undefined && token !== null) {
        const payloadBase64 = token.split('.')[1];
        const decodedJson = Buffer.from(payloadBase64, 'base64').toString();
        const decoded = JSON.parse(decodedJson)
        const exp = decoded.exp;
        const expired = (Date.now() >= exp * 1000)
        return expired
      } else {
        return true;
      }
    }

    return {
        loginUser,
        isAuthenticated,
        isTokenExpired,
        getUser,
        getToken,
        signOut,
        signUpUser,
        updatePassword
    }
}
